.wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  border-inline-end: 1px var(--ant-line-type) var(--ant-color-split);
  padding: 0 8px;

  a {
    display: flex;
  }

  &.mobile {
    border-inline-end: 0;
  }
}

.small {
  flex-direction: column;
}

.logo {
  height: 70px;
}

.appEnvLabel {
  font-size: var(--p1-body);
  color: var(--danger-5);
  font-weight: bold;
  margin-left: 5px;
}

.version {
  font-size: 12px;
  font-weight: 400;
  color: var(--primary-5);
}
